import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "./User.css";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { GiBackwardTime } from "react-icons/gi";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";
import useClickOutside from "../useClickOutside";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { HiOutlinePlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";

function VoyageList({ isSidebarExpanded, departmentID }) {
  const [voyageList, setVoyageList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const fetchTimeout = useRef(null);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const popupRef = useRef(null);
  const handleSort = (column) => {
    const currentOrder = sortOrder[column] === "asc" ? "desc" : "asc";

    setSortColumn(column);
    setSortOrder((prevOrder) => ({
      ...prevOrder,
      [column]: currentOrder,
    }));

    setIsSortPopup(false);

    const sortedSchedules = [...voyageList].sort((a, b) => {
      const aValue = a[column]?.toString().toLowerCase() || "";
      const bValue = b[column]?.toString().toLowerCase() || "";

      if (aValue < bValue) return currentOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return currentOrder === "asc" ? 1 : -1;
      return 0;
    });

    setVoyageList(sortedSchedules);
  };

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/atf/voyages`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          page: currentPage,
          per_page: itemsPerPage,
        },
      });
      setVoyageList(response?.data?.Voyages);
      setTotalItems(response?.data?.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };

  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Draft":
        return "gray";
      case "Completed":
        return "green";
      default:
        return "black";
    }
  };

  const handleViewClick = async (voyage_id) => {
    navigate(`/voyage-view/${voyage_id}`);
  };

  const formatDates = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) {
      return "NA";
    }

    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    return formatter.format(date);
  };

  const handleButtonClick = (index, event) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>All Voyages</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    className="search-bar"
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>

                <Link to="/voyageform" className="data-list-new">
                  <Tooltip title="New User" arrow>
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                </Link>

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
                {/* <button
                  className="sort-button"
                  onClick={handleSortpopup}
                  ref={buttonRef}
                >
                  <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <div className="sort-popup-content">
                      <div className="sort-by">
                        SORT BY{" "}
                        {sortOrder[sortColumn] === "asc"
                          ? "(Ascending)"
                          : "(Descending)"}
                      </div>
                      <div className="sort-by-button">
                        <button onClick={() => handleSort("department_name")}>
                          Department{" "}
                          {sortOrder["department_name"] === "asc" ? (
                            <MdExpandMore />
                          ) : (
                            <MdExpandLess />
                          )}
                        </button>
                        <br />
                        <button onClick={() => handleSort("preferred_vendor")}>
                          Preferred Vendor{" "}
                          {sortOrder["preferred_vendor"] === "asc" ? (
                            <MdExpandMore />
                          ) : (
                            <MdExpandLess />
                          )}
                        </button>
                        <br />
                        <button onClick={() => handleSort("pr_type")}>
                          PR Type{" "}
                          {sortOrder["pr_type"] === "asc" ? (
                            <MdExpandMore />
                          ) : (
                            <MdExpandLess />
                          )}
                        </button>
                        <br />
                        <button onClick={() => handleSort("updated_at")}>
                          Delivery Date{" "}
                          {sortOrder["updated_at"] === "asc" ? (
                            <MdExpandMore />
                          ) : (
                            <MdExpandLess />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>

          <div class="header-separator"></div>
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : voyageList?.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="">SR. NO.</th>
                        <th>VOYAGE NUMBER</th>
                        <th>DATE</th>
                        <th className="">STATUS</th>
                        <th>PRODUCT</th>
                        <th>TRIP NUMBER</th>
                        <th className="">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {voyageList?.length > 0 &&
                        voyageList?.map((voyage, index) => (
                          <tr key={voyage.id} className="hoverable-row">
                            <td>{voyage.serial_no}</td>
                            <td>{voyage.voyage_number}</td>
                            <td>{formatDates(voyage.date || "NA")}</td>
                            <td className="">
                              <div
                                // className="pr-request-status"
                                style={{
                                  color: getStatusColor(voyage.status),
                                }}
                              >
                                {voyage.status || "NA"}
                              </div>
                            </td>

                            <td>{voyage.products?.join(", ") || "NA"}</td>

                            {/* <td>
                              {(() => {
                                try {
                                  return voyage.products?.length
                                    ? JSON.parse(voyage.products[0]).join(", ")
                                    : "NA";
                                } catch (e) {
                                  return "Invalid Format";
                                }
                              })()}
                            </td> */}

                            <td>{voyage.trip_number}</td>

                            <td className="-pop">
                              <div className="" style={{display:"flex", gap:"12px"}}>
                                <button
                                  onClick={() => handleViewClick(voyage.id)}
                                  className="button-bg"
                                >
                                  View
                                </button>

                                <button
                                  className="edit-data-button"
                                  onClick={(event) =>
                                    handleButtonClick(index, event)
                                  }
                                >
                                  <div className="edit-button">
                                    <MdExpandMore />
                                  </div>
                                </button>
                              </div>
                            </td>
                            {selectedRowIndex === index && (
                              <div
                                className="edit-popup"
                                style={{
                                  position: "absolute",
                                  top: "60.5%",
                                  right: "5%",
                                }}
                                ref={popupRef}
                              >
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <Link
                                      to={`/edit-voyage/${voyage.id}`}
                                      className="inquiry-new"
                                    >
                                      <button className="edit-button-inquiry">
                                        <MdOutlineModeEditOutline /> Edit
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* {selectedRowIndex === index && (
                              <div
                                className="edit-popup"
                                style={{
                                  position: "absolute",
                                  top: "69.5%",
                                  right: "16%",
                                }}
                                ref={popupRef}
                              >
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <Link
                                      to={`/edit-voyage/${voyage.id}`}
                                      className="inquiry-new"
                                    >
                                      <button className="edit-button-inquiry">
                                        <MdOutlineModeEditOutline /> Edit
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Voyage List Found</div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default VoyageList;
